import React, { FC, useEffect } from "react";
import { useLocation, Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import { WhatsAppButton, WHATSAPP_PHONE_DISPLAY } from "components/WhatsAppContact/WhatsAppContact";
import Seo from "components/Seo/Seo";

export interface PayErrorProps {
  className?: string;
}

const btnGradient =
  "inline-flex items-center justify-center gap-2 rounded-full bg-gradient-to-r from-violet-600 to-fuchsia-600 px-7 py-3 text-base font-bold uppercase tracking-wide text-white shadow-lg shadow-violet-600/30 transition-all duration-200 hover:from-violet-500 hover:to-fuchsia-500 hover:shadow-violet-500/50 focus:outline-none focus-visible:ring-2 focus-visible:ring-violet-400 active:scale-95";
const btnGhost =
  "inline-flex items-center justify-center gap-2 rounded-full border border-white/15 bg-white/5 px-7 py-3 text-base font-medium text-slate-200 transition hover:bg-white/10";

const PayError: FC<PayErrorProps> = ({ className = "" }) => {
  const location = useLocation();

  useEffect(() => {
    const captureNotificationParameters = () => {
      const searchParams = new URLSearchParams(location.search);
      const version = searchParams.get("Ds_SignatureVersion");
      const params = searchParams.get("Ds_MerchantParameters");
      const signatureRecibida = searchParams.get("Ds_Signature");
      console.log(version, params, signatureRecibida);
    };
    captureNotificationParameters();
  }, [location.search]);

  return (
    <div className={`nc-PayPage relative min-h-screen overflow-hidden bg-gradient-to-b from-[#0c0a16] to-[#15101f] px-4 py-20 ${className}`} data-nc-id="PayPage">
      <Seo path="/pay-error" title="Pago no completado | Karaoke Rooms Barcelona" description="No se pudo completar el pago de tu reserva de karaoke." noindex />
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute left-1/2 top-0 h-80 w-80 -translate-x-1/2 rounded-full bg-rose-600/15 blur-[120px]" />
      </div>

      <div className="relative mx-auto max-w-lg">
        <div className="rounded-3xl border border-white/10 bg-white/[0.04] p-8 text-center shadow-2xl backdrop-blur-xl sm:p-10">
          <span className="mx-auto mb-6 grid h-16 w-16 place-items-center rounded-full bg-rose-500/15 text-rose-300">
            <XCircle size={36} />
          </span>
          <h1 className="text-2xl font-bold text-white sm:text-3xl">No se pudo completar la reserva ❌</h1>
          <p className="mt-3 text-slate-400">Ha habido un problema con el pago y no se ha realizado ningún cargo. Puedes intentarlo de nuevo.</p>
          <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
            <Link to="/checkout" className={btnGradient}>Reintentar</Link>
            <Link to="/rooms" className={btnGhost}>Volver a las salas</Link>
          </div>

          <div className="mt-8 border-t border-white/10 pt-6">
            <p className="text-sm text-slate-400">
              ¿Necesitas ayuda? Escríbenos por WhatsApp al{" "}
              <span className="font-semibold text-white">{WHATSAPP_PHONE_DISPLAY}</span>:
            </p>
            <div className="mt-3 flex justify-center">
              <WhatsAppButton text="Hola, he tenido un problema con el pago de mi reserva en Karaoke Rooms Barcelona y necesito ayuda." />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PayError;
